exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kv-remove-filter {\n  cursor: pointer;\n  display: flex;\n}\n", ""]);

// exports
